<template>
  <div class="bg-neutral p-4 h-full">
    <slot />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
export default defineComponent({
    name: 'InterviewShortCutContainer'
});
</script>
